import React, {Component} from 'react';
import axios from 'axios';
import update from 'immutability-helper';
import './Contact.css';
import validate from '../../helper/validate';
import {Row, Col, Container, Button, Alert, Form} from 'react-bootstrap';
import BlankWrap from '../../hoc/Blankwrap';

class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            name:'',
            email: '',
            phone: '',
            postcode: '',
            domcom: 'commercial',
            companyName : '',
            message: '',
            enquirySubmitted: false,
            enquirySuccess: null,
            invalid : {
                email : '',
                phone : '',
                name : '',
                companyName : '',
                postcode: '',
                message : ''
            }
        };
        //this.state.enquirySubmitted=true;
        //this.state.enquirySuccess=true;
    }

    nameChangeHandler = (event) => {
        this.setState({name:event.target.value});
    }
    emailChangeHandler = (event) => {
        this.setState({email:event.target.value});
    }
    phoneChangeHandler = (event) => {
        this.setState({phone:event.target.value});
    }
    messageChangeHandler = (event) => {
        this.setState({message:event.target.value});
    }
    postcodeChangeHandler = (event) => {
        this.setState({postcode:event.target.value});
    }
    companyNameChangeHandler = (event) => {
        this.setState({companyName:event.target.value});
    }
    
    domcomChangeHandler = (event) => {
        console.log(this.state);
        console.log(event.target.id)
        var newDomcom;
        if (event.target.id === 'com') {
            newDomcom = 'commercial';
        } else {
            newDomcom = 'domestic';
        }
        console.log(event.target);
        this.setState({domcom:newDomcom});
        
    }

    submitHandler = (event) => {
        if (!this.validateForm()) {
            console.log("validate failed");
            return false;
        }
        var subject;
        if (this.state.domcom === 'commercial') { 
            subject = "New enquiry from " + this.state.name + " at " + this.state.companyName;
        } else { 
            subject = "New enquiry from " + this.state.name;
        }
        var companyName = '';
        if (this.state.domcom === 'commercial') {
            companyName = this.state.companyName;
        }
        var message = 'Name: ' + this.state.name + '\r\nEmail: ' + this.state.email + '\r\nPhone: ' + this.state.phone + '\r\nPostcode: ' + this.state.postcode + '\r\nJob Type: ' + this.state.domcom + '\r\nCompany Name: ' + companyName + '\r\nMessage: ' + this.state.message;
        this.setState({enquirySubmitted: true});
        
        axios.post('https://invsfwgtwe.execute-api.eu-west-1.amazonaws.com/default/', {
            subject:subject,
            message:message           
        })
        .then((response) => {
            console.log(response);
            if (response.data['body-json'].MessageId) { 
                this.setState({enquirySuccess: true});
            } else {
                this.setState({enquirySuccess: false});
                console.log("ERROR - No messageId in response");
            }
        }).catch((err) => {
            console.log("error", err);
            this.setState({enquirySuccess: false});
        });
    }

    componentWillUpdate() {
        
    }

    render() {
        var statusOutput = null;
        if (this.state.enquirySubmitted === true) {
            if(this.state.enquirySuccess === false) {
                statusOutput = (
                    <Alert variant="danger">Error submitting enquiry, please try again. If the problem persists please get in touch via email or phone.</Alert>
                );
            } else if (this.state.enquirySuccess === true) {
                statusOutput = (
                    <Alert variant="success">Enquiry submitted successfuly. You will hear from us within 3 working days. </Alert>
                );
            } else {
                statusOutput = (
                    <Alert variant="success">Submitting enquiry, please wait.</Alert>
                );
            }
        }
        var nameInvalid = null;
        if (this.state.invalid.name) { 
            nameInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.name}</Alert>);
        }
        var emailInvalid = null;
        if (this.state.invalid.email) { 
            emailInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.email}</Alert>);
        }
        var phoneInvalid = null;
        if (this.state.invalid.phone) { 
            phoneInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.phone}</Alert>);
        }
        var postcodeInvalid = null;
        if (this.state.invalid.postcode) { 
            postcodeInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.postcode}</Alert>);
        }
        var companyNameInvalid = null
        if (this.state.invalid.companyName) { 
            companyNameInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.companyName}</Alert>);
        }
        var messageInvalid = null;
        if (this.state.invalid.message) {
            messageInvalid = (<Alert variant="danger" className="form-alert">{this.state.invalid.message}</Alert>);
        }
        const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
        let colClass;
        if (vw < 576) {
            colClass="drop-width";
        } else {
            colClass="drop-width";
        }
        
        var hidden, dom, com;
        if (this.state.domcom === 'domestic') {
            dom=true;
            com=false;
            hidden = 'hidden';
        } else {
            dom=false;
            com=true;
            hidden = '';
        }

        return (
            <BlankWrap>
                <section className="anchor3" id="contact"></section>
                <Row style={{width:'100%', margin:'auto', marginTop:'0', marginBottom:'3rem'}}>
                    <h1 style={{margin:'auto'}}>Get in Touch</h1>
                </Row>
                <Row style={{margin:'auto'}}>
                    <Col style={{textAlign:'left'}} xs={12} md={4}>
                        <div className={colClass}>
                            <p>Please get in touch for more information about the services we provide, or for a free, no obligation quotation. Our friendly team are waiting to discuss your requirements and help you with whatever you might need.
                                <br/><br/>You can give us a call, send us an email, or complete the contact form opposite and we'll get back to you as soon as we can.</p>
                            <p><span>&#9742;</span> 07718 922168</p>
                            <p><span>&#9993;</span> <a className='remove-decoration' style={{color:"white"}} href="mailto:info@infinitysolutions.org.uk">info@infinitysolutions.org.uk</a></p>
                            <p style={{display:'none'}}>
                                Address<br/>
                                <div style={{paddingLeft:'1.5rem'}}>
                                    Infinity Secure Solutions<br/>
                                    6 Poplar Close,<br/>
                                    Roxton,<br/>
                                    Bedfordshire,<br/>
                                    MK44 3EG
                                </div>
                            </p>
                        </div>
                    </Col>
                    <Col className={colClass} style={{textAlign:'left'}} xs={12} md={8}>
                        <Form>
                            <Form.Group>
                                <Form.Label>Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter your name" 
                                    value={this.state.name} 
                                    onChange={(event) => this.nameChangeHandler(event)}
                                    onBlur={() => this.validateName()}
                                ></Form.Control>
                                {nameInvalid}
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Email Address</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter your email address" 
                                    value={this.state.email} 
                                    onChange={(event) => this.emailChangeHandler(event)}
                                    onBlur={() => this.validateEmail()}
                                ></Form.Control>
                                {emailInvalid}
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter your telephone number" 
                                    value={this.state.phone} 
                                    onChange={(event) => this.phoneChangeHandler(event)}
                                    onBlur={() => this.validatePhone()}
                                ></Form.Control>
                                {phoneInvalid}
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Installation/Job Post Code</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter a post code" 
                                    value={this.state.postcode} 
                                    onChange={(event) => this.postcodeChangeHandler(event)}
                                    onBlur = {() => this.validatePostcode()}
                                ></Form.Control>
                                {postcodeInvalid}
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Domestic or Commercial</Form.Label><br></br>
                                <Form.Check onChange={(event) => this.domcomChangeHandler(event)} checked={dom} id="dom" name="domcom" type="radio" label="Domestic" inline/>
                                <Form.Check onChange={(event) => this.domcomChangeHandler(event)} checked={com} id="com" name="domcom" type="radio" label="Commercial" inline/>
                            </Form.Group>
                            <Form.Group className={hidden}>
                                <Form.Label>Company Name</Form.Label>
                                <Form.Control 
                                    type="text" 
                                    placeholder="Enter company name" 
                                    value={this.state.companyName} 
                                    onChange={(event) => this.companyNameChangeHandler(event)}
                                    onBlur={() => this.validateCompanyName()}
                                ></Form.Control>
                                {companyNameInvalid}
                            </Form.Group>
                            <Form.Group>
                                <Form.Label>Message</Form.Label>
                                <Form.Control 
                                    as="textarea" 
                                    rows='10' 
                                    placeholder="Enter your message here" 
                                    value={this.state.message} 
                                    onChange={(event) => this.messageChangeHandler(event)} 
                                    onBlur = {()=> this.validateMessage()}
                                ></Form.Control>
                                {messageInvalid}
                            </Form.Group>
                            {statusOutput}
                            <Button onClick={this.submitHandler} variant="dark" className="enquiry-button" id='enquiry-submit'>Submit</Button>
                            
                        </Form>
                    </Col>
                </Row>
            </BlankWrap>
        );
    }

    validateEmail() {
        var newState;
        if (this.state.email === "") {
            newState = update(this.state, {invalid : {email : {$set : ""}}});
            this.setState(newState);
            return false;
        }
        var result = validate.validateEmail(this.state.email);
        if (!result){
            newState = update(this.state, {invalid : {email : {$set : "Email address is not valid. Please enter a valid email address."}}})
        } else {
            newState = update(this.state, {invalid : {email : {$set : ""}}});
        }
        console.log("email", result, newState);
        this.setState(newState);
        return result;   
    }
    validatePostcode() {
        var newState;
        if (this.state.postcode === "") return false;
        var result = validate.validatePostcode(this.state.postcode);    
        if (!result){
            newState = update(this.state, {invalid : {postcode : {$set : "Postcode is not valid. Please enter a valid UK postcode."}}})
        } else {
            newState = update(this.state, {invalid : {postcode : {$set : ""}}});
        }
        this.setState(newState);
        return result;
    }
    validatePhone() {
        var newState;
        if (this.state.phone === "") {
            newState = update(this.state, {invalid : {phone : {$set : ""}}});
            this.setState(newState);
            return false;
        }
        var result = validate.validatePhone(this.state.phone);
        if (!result){
            newState = update(this.state, {invalid : {phone : {$set : "Telephone number is not valid. Please enter a valid UK telephone number."}}});
        } else {
            newState = update(this.state, {invalid : {phone : {$set : ""}}});
        }
        this.setState(newState);
        return result;
    }
    validateName() {
        if (this.state.name === "") return false;
        var result = validate.validateName(this.state.name);
        var newState;
        if (!result){
            newState = update(this.state, {invalid : {name : {$set : "Name is not valid. Please enter a valid name."}}});
        } else {
            newState = update(this.state, {invalid : {name : {$set : ""}}});
        }
        this.setState(newState);
        return result;
    }
    validateCompanyName() {
        if (this.state.domcom === "domestic") { 
            this.setState({companyName : ""});
            return true;
        } else if (this.state.companyName === "") {
            return false;
        }
        var result = validate.validateCompanyName(this.state.companyName);
        var newState;
        if (!result){
            newState = update(this.state, {invalid : {companyName : {$set : "Company name is not valid. Please enter a valid name."}}});
        } else {
            newState = update(this.state, {invalid : {companyName : {$set : ""}}});
        }
        this.setState(newState);
        return result;
    }
    validateMessage() {
        if (this.state.message === "") return false;
        var result = validate.validateMessage(this.state.message);
        var newState;
        if (!result){
            newState = update(this.state, {invalid : {message : {$set : "Message is not valid. Please enter a valid message."}}});
        } else {
            newState = update(this.state, {invalid : {message : {$set : ""}}});
        }
        this.setState(newState);
        return result;
    }

    validateForm() {
        var validName = (!validate.validateName(this.state.name)) ? "Name is not valid. Please enter a valid name." : "";
        var validEmail = "";
        var validPhone = "";
        if (this.state.phone === "" && this.state.email === ""){ 
            validEmail = "Please provide either an email address or telephone number.";
            validPhone = "Please provide either an email address or telephone number."
        } else {
            if (this.state.email !== "") validEmail= (!validate.validateEmail(this.state.email)) ? "Email address is not valid. Please enter a valid email address." : "";
            if (this.state.phone !== "") validPhone = (!validate.validatePhone(this.state.phone)) ? "Telephone number is not valid. Please enter a valid UK telephone number." : "";
            
        }  
        var validPostcode = (!validate.validatePostcode(this.state.postcode)) ? "Postcode is not valid. Please enter a valid UK postcode." : "";
        var validCompanyName = ""
        if (this.state.domcom === "commercial"){
            validCompanyName = (!validate.validateCompanyName(this.state.companyName)) ? "Company name is not valid. Please enter a valid name." : "";
        }
        var validMessage = (!validate.validateMessage(this.state.message)) ? "Message is not valid. Please enter a valid message." : "";
        
        var newState = update(this.state, {
            invalid : {
                name : {$set : validName},
                email : {$set : validEmail},
                phone : {$set : validPhone},
                postcode : {$set : validPostcode},
                companyName : {$set : validCompanyName},
                message : {$set : validMessage}
            }
        });
        this.setState(newState);
        if (
            validName === "" &&
            validEmail === "" &&
            validPhone === "" &&
            validPostcode === "" &&
            validCompanyName === "" &&
            validMessage === ""
        ) return true;

        return false;
    }
}

export default Contact;